// extracted by mini-css-extract-plugin
export var audioPlayer = "_tf-0";